import { format } from 'date-fns';

export function parseDate(date: Date, formated: string = 'dd MMMM yyyy') {
  return format(new Date(date), formated);
}